"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "Why focus exclusively on Apple HomeKit?",
  answer: "We believe in the 'Digital Zen' philosophy. Apple HomeKit offers the most secure, private, and seamless integration for home automation, aligning perfectly with our commitment to simple, distraction-free living."
}, {
  question: "Do I need a dedicated hub for my smart home?",
  answer: "To experience the full potential of moza casa—including remote access and advanced automation recipes—we recommend an Apple TV or HomePod mini as your central home hub."
}, {
  question: "Is smart home technology difficult to maintain?",
  answer: "Our 'Moza Method' focuses on reliability over complexity. By choosing high-quality Thread and Matter-enabled devices, your home stays connected with minimal intervention, keeping your life simple."
}, {
  question: "Can I automate an older home with moza casa?",
  answer: "Absolutely. Simple living isn't about new construction; it's about thoughtful upgrades. We provide tips on smart switches and plugs that bring modern intelligence to classic architecture without invasive rewiring."
}];
export default function FittingFaq() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="225096" id="common-questions" className="bg-background text-foreground py-24 md:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl">
        <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-3xl md:text-5xl font-default font-bold text-primary tracking-tight mb-4">
              Common Questions
            </h2>
            <p className="text-muted-foreground font-default text-lg md:text-xl max-w-2xl mx-auto">
              Clarifying the path to a more automated, intentional lifestyle.
            </p>
          </div>

          <div className="bg-transparent rounded-none p-6 md:p-10 lg:p-12 shadow-none border-none">
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border/40 py-2">
                  <AccordionTrigger className="text-left text-lg md:text-[18px] font-default font-bold text-primary hover:no-underline hover:text-primary/70 transition-colors">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground font-default text-base md:text-[17px] leading-relaxed pt-2 pb-6">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>)}
            </Accordion>
          </div>
        </div>
      </div>
    </section>;
}